import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import { round } from 'lodash';
import enhance from './EscrowFunds.enhancer';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { PayPalButton } from 'react-paypal-button-v2';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

class EscrowFunds extends React.Component {
  constructor() {
    super();

    const initialState = {
      isLoadingFinancials: false,
      isBalanceMessageDialogOpen: false
    };

    this.state = {
      ...initialState
    };
  }

  closeDrawer() {
    this.props.closeClick();
  }

  componentWillMount() {
    // add financials to props
    // if balance = null get the finances
    // start spinner

    if (this.props.finances.currentBalance == null) {
      this.setState({
        isLoadingFinancials: true
      });
      this.props.getCompanyFinances(this.onGetCompanyFinancesComplete);
    }
  }

  onGetCompanyFinancesComplete = () => {
    this.setState({
      isLoadingFinancials: false
    });
  };

  onPayWithBalanceComplete = () => {
    this.setState({
      isLoadingFinancials: false
    });
    this.props.closeClick();
  };

  payWithBalanceClick = () => {
    // check there is enough balance, if not open popup
    if (
      this.props.deal.currentProposal.payout >
      this.props.finances.currentBalance
    ) {
      this.setState({
        isBalanceMessageDialogOpen: true
      });
    } else {
      this.setState({
        isLoadingFinancials: true
      });
      this.props.payWithBalance(
        this.props.deal.id,
        this.onPayWithBalanceComplete
      );
    }
  };

  onCloseBalanceDialog = () => {
    this.setState({
      isBalanceMessageDialogOpen: false
    });
  };

  navigateToSettings = () => {
    this.onCloseBalanceDialog();
    this.props.closeClick();
    this.props.history.push('/settings');
  };

  render() {
    const { classes, open, deal, paymentIsProcessing, finances } = this.props;
    const { isLoadingFinancials, isBalanceMessageDialogOpen } = this.state;

    return (
      <React.Fragment>
        <Drawer
          onClose={this.closeDrawer.bind(this)}
          anchor="right"
          open={open}
        >
          {deal && (
            <div className={classes.list} role="presentation">
              <div className={classes.buttonsContainer}>
                <div className={classes.totalContainer}>
                  <Typography variant="h4" display="inline">
                    Total: ${deal.currentProposal.payout.toLocaleString()}
                  </Typography>
                </div>
                {finances.currentBalance > 0 && (
                  <div className={classes.totalContainer}>
                    <Typography
                      display="inline"
                      align="center"
                      className="info-helper-text"
                    >
                      Pay using your balance ($
                      {round(finances.currentBalance, 2)})
                    </Typography>
                    <div>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.balanceButton}
                        onClick={this.payWithBalanceClick}
                      >
                        Pay with Balance
                      </Button>
                    </div>
                    <div className={classes.orText}>
                      <Typography
                        display="inline"
                        align="center"
                        className="info-helper-text"
                      >
                        or
                      </Typography>
                    </div>
                  </div>
                )}
                <Typography
                  variant="body1"
                  className={classes.secureText}
                  className="info-helper-text"
                >
                  Please secure funds using one of the following methods:
                </Typography>
                <PayPalButton
                  amount={deal.currentProposal.payout}
                  onSuccess={(details, data) => {
                    const paymentDetails = {
                      ...details,
                      ...data,
                      paymentId: data.orderID,
                      companyId: deal.companyId,
                      influencerId: deal.influencerId,
                      amount: deal.currentProposal.payout
                    };
                    this.props.handleprocessEscrowFunds(
                      paymentDetails,
                      deal.id
                    );
                  }}
                  catchError={err => {
                    console.log(err);
                    alert('error');
                  }}
                  options={{
                    clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID_BUSINESS
                  }}
                />
              </div>
            </div>
          )}
          {paymentIsProcessing && (
            <div className={classes.spinnerContainer}>
              <CircularProgress className={classes.downArrow} />
            </div>
          )}
          {isLoadingFinancials && (
            <div className={classes.spinnerContainer}>
              <CircularProgress className={classes.downArrow} />
            </div>
          )}
        </Drawer>
        <Dialog
          id="balance-warning-dialog"
          open={isBalanceMessageDialogOpen}
          onClose={this.onCloseBalanceDialog}
          disableAutoFocus={true}
          onBackdropClick={this.onCloseBalanceDialog}
          PaperProps={{
            style: {
              minWidth: '400px',
              maxWidth: '400px',
              // height: '500px',
              padding: '20px'
            }
          }}
        >
          <div>
            <Typography align="center" variant="h6">
              You don't have enough balance!
            </Typography>
          </div>
          <div className={classes.balanceMessageContainer}>
            <Button
              variant="contained"
              color="primary"
              className={classes.balanceButton}
              onClick={this.navigateToSettings}
            >
              Add to Balance
            </Button>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

EscrowFunds.PropTypes = {
  isCompany: PropTypes.string
};

export default enhance(EscrowFunds);



// WEBPACK FOOTER //
// ./src/components/deals/escrow-funds/EscrowFunds.js